import type React from 'react'
import { cn } from '@/utils'

/* Right-side shell with fixed, exact paddings/width for visual parity with the left rail */
export function PanelShell({
  title,
  children,
  fullWidthHeaderBorder = false,
}: {
  title: string
  children: React.ReactNode
  /** Draw the header rule edge-to-edge; title padding stays on the header row, not the shell. */
  fullWidthHeaderBorder?: boolean
}) {
  return (
    <div
      data-right-panel-shell="true"
      className={cn(
        'flex h-full w-[var(--panel-title-width)] min-w-0 flex-col overflow-hidden border-l border-border bg-background',
        !fullWidthHeaderBorder && 'px-4'
      )}
    >
      <div
        className={cn(
          'flex h-12 shrink-0 items-center',
          fullWidthHeaderBorder && 'border-b border-border px-4'
        )}
      >
        <h2 className="text-base font-sans font-semibold text-foreground">{title}</h2>
      </div>
      <div
        className={cn(
          // This wrapper's own `overflow-y-auto` never actually activates — each panel's own root
          // (e.g. BackgroundsPanel) is a `flex-1 min-h-0` child that clips and scrolls itself
          // first, so its box never grows taller than what's allotted here. The scrollbar-gutter
          // reservation therefore belongs on THAT inner element, not here — reserving it on this
          // (never-scrolling) wrapper only wastes space with no anti-shift benefit. Plain
          // symmetric padding is enough at this level.
          'flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-x-hidden overflow-y-auto pb-4',
          fullWidthHeaderBorder && 'pl-4 pt-4'
        )}
      >
        {children}
      </div>
    </div>
  )
}
